module.exports = __webpack_public_path__ + "media/images/brand/logo-white-017e1bd7adbde6169d7d84e73d7a50db.png";